import { useCallback, useMemo, useState } from 'react';

/**
 * Ordenação de tabela por clique no cabeçalho.
 *
 * Trata número, data e texto separadamente: comparar valores monetários como
 * string colocaria "R$ 9,00" acima de "R$ 100,00".
 */
export function useOrdenacao(itens, campoInicial = null, ascInicial = true) {
  const [campo, setCampo] = useState(campoInicial);
  const [asc, setAsc] = useState(ascInicial);

  const ordenarPor = useCallback(
    (novoCampo) => {
      if (novoCampo === campo) {
        setAsc((v) => !v);
      } else {
        setCampo(novoCampo);
        setAsc(true);
      }
    },
    [campo]
  );

  const ordenados = useMemo(() => {
    const lista = itens || [];
    if (!campo) return lista;

    const copia = [...lista];
    copia.sort((a, b) => {
      const va = a?.[campo];
      const vb = b?.[campo];

      if (va === null || va === undefined) return 1;
      if (vb === null || vb === undefined) return -1;

      const na = Number(va);
      const nb = Number(vb);
      const ambosNumericos =
        va !== '' && vb !== '' && !Number.isNaN(na) && !Number.isNaN(nb);

      const cmp = ambosNumericos
        ? na - nb
        : String(va).localeCompare(String(vb), 'pt-BR', { numeric: true, sensitivity: 'base' });

      return asc ? cmp : -cmp;
    });
    return copia;
  }, [itens, campo, asc]);

  return { ordenados, campo, asc, ordenarPor };
}

export default useOrdenacao;
